<div class="admin-container">
  @if (selectedTab() === 'users') {
    <header class="admin-users-page-header">
      <div class="admin-users-page-header-left">
        <aio-header class="admin-users-page-title page-title" [title]="getPageTitle()" />
        <span class="admin-users-page-count">{{ usersTotalCount }} entries</span>
      </div>
      <div class="admin-users-page-header-right">
        <div class="admin-users-search-wrap">
          <app-search-input
            [(ngModel)]="usersHeaderSearchTerm"
            [placeholder]="'Search users'"
            [debounceTime]="1500"
            (searchChange)="onUsersToolbarSearchChange($event)"
          />
        </div>
        <div class="admin-users-header-actions">
          <aio-button
            class="add-button-with-icon"
            appearance="primary"
            size="sm"
            iconName="plus"
            [disabled]="!hasUsersAddEditPermission()"
            (pressed)="onAddUserFromHeader()"
          >
            Add User
          </aio-button>
        </div>
      </div>
    </header>
    <section class="admin-users-view-mode-toggle" aria-label="User list type">
      <aio-segmented-control
        [value]="usersViewMode()"
        [options]="usersViewModeOptions"
        (valueChange)="onUsersViewModeChange($event)"
      />
    </section>
    <!--TODO: Add back in when we have a KPI API-->
    <!-- <section class="admin-users-kpis" aria-label="User statistics">
      <div class="admin-users-kpis-row">
        <div class="admin-kpi-card admin-kpi-card--total">
          <div class="admin-kpi-card__body">
            <span class="admin-kpi-card__value">{{ usersKpiTotal }}</span>
            <span class="admin-kpi-card__label">Total Users</span>
          </div>
        </div>
        <div class="admin-kpi-card admin-kpi-card--active">
          <div class="admin-kpi-card__icon-wrap admin-kpi-card__icon-wrap--active">
            <span class="admin-kpi-card__icon-circle admin-kpi-card__icon-circle--active" aria-hidden="true">
              <img src="assets/icons/check_white.svg" alt="" width="11" height="11" />
            </span>
          </div>
          <div class="admin-kpi-card__body">
            <span class="admin-kpi-card__value">{{ usersKpiActive }}</span>
            <span class="admin-kpi-card__label">Active</span>
          </div>
        </div>
        <div class="admin-kpi-card admin-kpi-card--invited">
          <div class="admin-kpi-card__icon-wrap admin-kpi-card__icon-wrap--invited">
            <img src="assets/icons/email/send_blue.svg" alt="" width="18" height="18" class="admin-kpi-card__send-icon" />
          </div>
          <div class="admin-kpi-card__body">
            <span class="admin-kpi-card__value">{{ usersKpiInvited }}</span>
            <span class="admin-kpi-card__label">Invited</span>
          </div>
        </div>
        <div class="admin-kpi-card admin-kpi-card--restricted">
          <div class="admin-kpi-card__icon-wrap admin-kpi-card__icon-wrap--restricted" aria-hidden="true">
            <svg class="admin-kpi-card__restricted-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.75" />
              <path d="M7 7l10 10" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" />
            </svg>
          </div>
          <div class="admin-kpi-card__body">
            <span class="admin-kpi-card__value">{{ usersKpiRestricted }}</span>
            <span class="admin-kpi-card__label">Restricted</span>
          </div>
        </div>
      </div>
    </section> -->
    <section class="admin-users-filters-bar" aria-label="User list filters">
      <!-- Same structure/classes as dashboard app-prime-ng-data-table text filters (see prime-ng-data-table.component.html). -->
      <div class="text-filters-row text-filters-row--admin-shell">
        <div class="text-filters-section">
          <div class="text-filters-label">Filters:</div>
          <div class="text-filters-buttons">
            <div class="filter-button-wrapper">
              <button
                type="button"
                class="text-filter-button"
                [class.active]="shellFiltersRole"
                (click)="openRoleShellFilter()"
                title="Role"
              >
                <img
                  src="assets/icons/filters/local_offer.svg"
                  alt=""
                  class="text-filter-icon icon-sm"
                />
                <span class="text-filter-text">Role</span>
              </button>
              @if (roleFilterModalOpen && roleFilterModalConfig) {
                <app-filter-modal
                  [config]="roleFilterModalConfig"
                  [isOpen]="roleFilterModalOpen"
                  (filterChange)="onRoleShellFilterApplied($event)"
                  (closeModal)="closeRoleShellFilterModal()"
                />
              }
            </div>
            @if (usersViewMode() === 'internal') {
            <div class="filter-button-wrapper">
              <button
                type="button"
                class="text-filter-button"
                [class.active]="shellFiltersStatus"
                (click)="openStatusShellFilter()"
                title="Status"
              >
                <img
                  src="assets/icons/filters/status.svg"
                  alt=""
                  class="text-filter-icon icon-sm"
                />
                <span class="text-filter-text">Status</span>
              </button>
              @if (statusFilterModalOpen && statusFilterModalConfig) {
                <app-filter-modal
                  [config]="statusFilterModalConfig"
                  [isOpen]="statusFilterModalOpen"
                  (filterChange)="onStatusShellFilterApplied($event)"
                  (closeModal)="closeStatusShellFilterModal()"
                />
              }
            </div>
            }
            @if (showUsersClearFilters()) {
              <aio-button appearance="tertiary" size="sm"
                type="button"
                class="clear-all-filters-btn"
                iconName="close"
                label="Clear All"
                (pressed)="clearAllUsersFiltersFromShell()"
                title="Clear all filters"
              />
            }
          </div>
        </div>
      </div>
    </section>
  }
  @if (selectedTab() === 'roles') {
    <header class="admin-users-page-header">
      <div class="admin-users-page-header-left">
        <aio-header class="admin-users-page-title page-title" [title]="getPageTitle()" />
        <span class="admin-users-page-count">{{ rolesTotalCount }} entries</span>
      </div>
      <div class="admin-users-page-header-right">
        <div class="admin-users-search-wrap">
          <app-search-input
            [(ngModel)]="rolesHeaderSearchTerm"
            [placeholder]="'Search roles'"
          />
        </div>
        <div class="admin-users-header-actions">
          <aio-button
            class="add-button-with-icon"
            appearance="primary"
            size="sm"
            iconName="plus"
            [disabled]="!hasRolesAddEditPermission()"
            (pressed)="onAddRoleFromHeader()"
          >
            Add Role
          </aio-button>
        </div>
      </div>
    </header>
  }
  @if (selectedTab() === 'users') {
    <app-admin-users
      [listMode]="usersViewMode()"
      (usersTotalChange)="onUsersTotalChange($event)"
      (headerSearchReset)="onUsersHeaderSearchReset()"
      (textFiltersShellStateChange)="onTextFiltersShellStateChange($event)"
    />
  }
  @if (selectedTab() === 'roles') {
    <app-user-roles (rolesTotalChange)="onRolesTotalChange($event)" />
  }
</div>